module.exports = __webpack_public_path__ + "static/media/im4.5687f3c4.png";